import DashboardIcon from "@mui/icons-material/Dashboard";
import BarChartIcon from "@mui/icons-material/BarChart";
import PeopleIcon from "@mui/icons-material/People";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import ForumIcon from "@mui/icons-material/Forum";
import YouTubeIcon from "@mui/icons-material/YouTube";
import ListAltIcon from "@mui/icons-material/ListAlt";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import SchoolIcon from "@mui/icons-material/School";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";

/**
 * MUI icon components for coach main nav — kept in sync with `components/MenuItem.jsx`.
 * First matching rule wins (more specific paths must appear first).
 */
const RULES = [
  [/^\/home\/training-plans-v2(\/|$)/, ListAltIcon],
  [/^\/home\/protocols(\/|$)/, ListAltIcon],
  [/^\/home\/dashboard(\/|$)/, DashboardIcon],
  [/^\/home\/reports(\/|$)/, BarChartIcon],
  [/^\/home\/clients(\/|$)/, PeopleIcon],
  [/^\/home\/coaches(\/|$)/, RecordVoiceOverIcon],
  [/^\/home\/messages(\/|$)/, ForumIcon],
  [/^\/home\/shared-videos(\/|$)/, YouTubeIcon],
  [/^\/home\/exercises(\/|$)/, FitnessCenterIcon],
  [/^\/home\/(recipes|meal-plans|supplements|ingredients)(\/|$)/, RestaurantIcon],
  [/^\/home\/library(\/|$)/, LibraryBooksIcon],
  [/^\/home\/learn(\/|$)/, SchoolIcon],
  [/^\/home\/admin(\/|$)/, SettingsIcon],
  [/^\/home\/developers(\/|$)/, SettingsIcon],
  [/^\/home\/profile(\/|$)/, PersonIcon],
  [/^\/home$/, DashboardIcon],
  [/^\/home\/$/, DashboardIcon],
];

/** @param {string} pathname */
export function getNavIconComponentForPathname(pathname) {
  for (const [re, Icon] of RULES) {
    if (re.test(pathname)) return Icon;
  }
  return null;
}
